const CAP6 = {
  id: 6,
  slug: "cap6-proof-of-work",
  title: "Capítulo 6 — Proof of Work (PoW)",
  sections: [
    {
      heading: "¿Qué es Proof of Work?",
      text: [
        "Proof of Work (PoW) o **Prueba de Trabajo** es el algoritmo de consenso más antiguo, utilizado por primera vez en **Bitcoin en 2009**.",
        "Su objetivo principal es asegurar que solo las transacciones legítimas sean registradas en la blockchain, evitando fraudes y manteniendo la integridad de la red.",
        "Fue el mecanismo que permitió que Bitcoin funcionara sin una autoridad central, creando un sistema seguro, descentralizado y resistente a manipulaciones."
      ]
    },
    {
      heading: "¿Cómo funciona PoW?",
      text: [
        "En PoW, los participantes llamados **mineros** compiten entre sí usando poder computacional para resolver un problema matemático extremadamente difícil.",
        "El primer minero en resolver correctamente ese problema gana el derecho de **proponer un nuevo bloque** y añadirlo a la blockchain.",
        "Una vez validado por otros nodos, ese bloque se convierte en parte del historial permanente de la red."
      ],
      bluepoint: [
        "🔹 Los problemas matemáticos son difíciles de resolver, pero fáciles de verificar.",
        "🔹 El proceso requiere mucho poder computacional (electricidad + hardware especializado).",
        "🔹 El minero que gana recibe recompensas y comisiones de transacciones."
      ]
    },
    {
      heading: "¿Qué es un minero?",
      text: [
        "**Un minero es un equipo de hardware especializado que ejecuta un software para procesar transacciones, validar bloques y asegurar la red.**",
        "Hoy en día, se utilizan principalmente equipos ASIC (Application Specific Integrated Circuit), diseñados específicamente para minar con alta eficiencia."
      ]
    },
    {
      heading: "La regla de la cadena más larga",
      text: [
        "PoW sigue un concepto llamado **Regla de la Cadena Más Larga**, que dice:",
        "**La versión válida de la blockchain es aquella que tiene el mayor trabajo acumulado (es decir, más esfuerzo computacional).**",
        "Esto evita que actores maliciosos creen versiones alternativas falsas de la red."
      ]
    },
    {
      heading: "Tolerancia a fallas bizantinas",
      bluepoint: [
        "Gracias a su mecanismo de validación, PoW ofrece **tolerancia a fallas bizantinas**, lo que significa que:",
        "🔹 La red puede seguir funcionando incluso si algunos participantes actúan de forma deshonesta.",
        "🔹 Los nodos honestos siempre convergen hacia una única versión válida de la blockchain.",
        "🔹 Se previene el **doble gasto**, donde alguien podría intentar gastar la misma moneda dos veces."
      ]
    },
    {
      heading: "Ventajas de Proof of Work",
      bluepoint: [
        "🔒 **Alta seguridad:** se necesita un enorme poder computacional para alterar la red.",
        "🌎 **Descentralización:** fomenta la participación de miles de mineros independientes.",
        "🛡️ **Protección contra ataques como el 51% y DDoS.**",
        "📜 **Garantiza inmutabilidad de las transacciones.**"
      ]
    },
    {
      heading: "Limitaciones de PoW",
      bluepoint: [
        "⚡ Alto consumo energético debido al uso constante de hardware especializado.",
        "🐌 Procesamiento lento comparado con otros mecanismos (menor escalabilidad).",
        "💸 No es adecuado para micropagos o aplicaciones que requieren alta velocidad."
      ]
    },
    {
      heading: "Ejemplos de redes que utilizan PoW",
      bluepoint: [
        "🔹 **Bitcoin (BTC)** — primera blockchain que implementó PoW.",
        "🔹 **Litecoin (LTC)** — versión más rápida y ligera de Bitcoin.",
        "🔹 **Monero (XMR)** — enfocado en privacidad.",
        "🔹 **Dogecoin (DOGE)** — basado inicialmente en Litecoin."
      ]
    },
    {
   
      note: [
        "Proof of Work fue el primer algoritmo que permitió que una red descentralizada funcionara sin intermediarios.",
        "Ha demostrado ser extremadamente seguro y resistente a ataques, aunque su eficiencia energética y escalabilidad han dado lugar a nuevos mecanismos como **Proof of Stake (PoS)**.",
        "Hoy sigue siendo un **pilar fundamental en la historia y evolución de la tecnología blockchain**."
      ]
    }
  ]
};

export default CAP6;
